import { GOOGLE_SSO_CLIENT_ID, MICROSOFT_SSO_CLIENT_ID } from '@/config';
import { SsoProviderConfig, SsoProviderId } from './sso-models';

function googleConfig(): SsoProviderConfig | null {
    if (!GOOGLE_SSO_CLIENT_ID) {
        return null;
    }

    // No redirect uri: Google Identity Services returns the token to the page
    // that rendered the button, so only the origin has to be registered.
    return {
        provider: 'google',
        adapter: 'gis',
        clientId: GOOGLE_SSO_CLIENT_ID
    };
}

function microsoftConfig(): SsoProviderConfig | null {
    if (!MICROSOFT_SSO_CLIENT_ID) {
        return null;
    }

    return {
        provider: 'microsoft',
        adapter: 'oidc',
        clientId: MICROSOFT_SSO_CLIENT_ID,
        // `organizations` rather than `common`, and fixed rather than
        // configurable: the API only accepts work/school accounts, so keeping
        // personal ones out of the account picker is better than failing them
        // after they have signed in. Narrowing to a single tenant would be a
        // product decision, not a deployment one.
        authority: 'https://login.microsoftonline.com/organizations/v2.0',
        scopes: ['openid', 'email', 'profile']
    };
}

const BUILDERS: Record<SsoProviderId, () => SsoProviderConfig | null> = {
    google: googleConfig,
    microsoft: microsoftConfig
};

export function getSsoProviderConfig(
    provider: SsoProviderId
): SsoProviderConfig | null {
    return BUILDERS[provider]();
}

/** Providers with a client id in this build. Anything else is hidden rather than shown broken. */
export function getEnabledSsoProviders(): SsoProviderId[] {
    return (Object.keys(BUILDERS) as SsoProviderId[]).filter(
        (provider) => BUILDERS[provider]() !== null
    );
}
